import { render, staticRenderFns } from "./latest-news.vue?vue&type=template&id=08afbd2f&scoped=true"
import script from "./latest-news.vue?vue&type=script&lang=js"
export * from "./latest-news.vue?vue&type=script&lang=js"
import style0 from "./latest-news.vue?vue&type=style&index=0&id=08afbd2f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08afbd2f",
  null
  
)

export default component.exports